import { Box, Grid, Paper, ToggleButton, ToggleButtonGroup, Typography, Snackbar, Button, TextField, Tooltip, MenuItem, Autocomplete } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../libs/contexts/authContext';
import PerformanceScatterplot from './PerformanceScatterplot';
import ClearIcon from '@mui/icons-material/Clear';
import StarIcon from '@mui/icons-material/Star';
import CircleIcon from '@mui/icons-material/Circle';
import InfoIcon from '@mui/icons-material/InfoOutlined';

function Scorecard({ ...props }) {
  const [simulateStatus, setSimulateStatus] = useState('actual')
  const [last25, setLast25] = useState('false')
  const { affiliateCode } = useContext(AuthContext)
  const [qualityColor, setQualityColor] = useState('#263497')
  const [simQualityColor, setSimQualityColor] = useState('#263497')
  const [approvalColor, setApprovalColor] = useState('#263497')
  const [freeLookColor, setFreeLookColor] = useState('#263497')
  const [fourMonthColor, setFourMonthColor] = useState('#263497')
  const [underwritingInaccColor, setUnderwritingInaccColor] = useState('#263497')
  const [excessiveAppColor, setExcessiveAppColor] = useState('#263497')
  const [disableLast25, setDisableLast25] = useState(false)
  const [simulateFields, setSimulateFields] = useState(false)
  const [simulateApproval, setSimulateApproval] = useState(null)
  const [simulateFreeLook, setSimulateFreeLook] = useState(null)
  const [simulateFourMonth, setSimulateFourMonth] = useState(null)
  const [simulateQualityScore, setSimulateQualityScore] = useState(null)
  const [notEnoughMessage, setNotEnoughMessage] = useState(false)
  const [distributor, setDistributor] = useState('1')
  const [agency, setAgency] = useState('1')
  const [product, setProduct] = useState('1')
  const [agencies, setAgencies] = useState([])
  const [products, setProducts] = useState([])
  const [distributors, setDistributors] = useState([])
  const [agentList, setAgentList] = useState([]);

  const agents = ['Jane Doe', 'John Doe', 'Bob Smith']

  const qualityScoreMessage =
    "Measure of an agent's overall quality of business. The higher the score the better an agent's quality of business is, with 0 being the lowest possible score and 10 being the highest. This score is determined by an agent's approval rate, free look cancel/first payment failure, and 4-month lapse rate."
  const approvalRateMessage =
    "Measure of how many of an agent's applications are approved by underwriting out of all applications that were fully underwritten."
  const freeLookCancelMessage =
    "Measure of how many of an agent's policies were not taken in the first 30 days (free-look) or not paid for by the insured out of all policies that were fully issued."
  const fourMonthLapseMessage =
    "Measure of how many of an agent's issued policies have lapsed within the first four months, out of all issued policies that are currently active and have a tenure of 4 months or greater."
  const fieldUWInaccuracyMessage =
    "Measure of misrepresentation determined during the underwriting process on an application. The lower the percentage the better an agent's field underwriting inaccuracy is (low misrepresentation)."
  const excessiveAppActivityMessage =
    'Measure of how many times an applicant has applied/re-applied for a life insurance product(s) with multiple carriers out of all policies submitted to underwriting by an agent. The higher the percentage the greater the risk.'
  const numApplicationsMessage = "Total number of an agent's applications that have been fully underwritten."
  const numPoliciesIssued = "Total number of an agent's policies that have been issued by the carrier."

  const handleSimulateToggle = (event, newStatus) => {
    if (newStatus !== null) {
      setSimulateStatus(newStatus)
      setSimulateFields(!simulateFields)
    }
  }

  const handleLast25Toggle = (event, newValue) => {
    if (newValue !== null) {
      setLast25(newValue)
    }
  }

  const handleApprovalSimulate = (event) => {
    setSimulateApproval(event.target.value)
  }

  const handleFreeLookSimulate = (event) => {
    setSimulateFreeLook(event.target.value)
  }

  const handleFourMonthSimulate = (event) => {
    setSimulateFourMonth(event.target.value)
  }

  const calculateApprovalBracket = () => {
    let approvalBracket = 0
    if (simulateApproval == 100) {
      approvalBracket = 5
    } else if (simulateApproval >= 95) {
      approvalBracket = 4.75
    } else if (simulateApproval >= 90) {
      approvalBracket = 4.5
    } else if (simulateApproval >= 85) {
      approvalBracket = 4.25
    } else if (simulateApproval >= 80) {
      approvalBracket = 4
    } else if (simulateApproval >= 75) {
      approvalBracket = 3.75
    } else if (simulateApproval >= 70) {
      approvalBracket = 3.5
    } else if (simulateApproval >= 65) {
      approvalBracket = 3.25
    } else if (simulateApproval >= 60) {
      approvalBracket = 3
    } else if (simulateApproval >= 55) {
      approvalBracket = 2.5
    } else if (simulateApproval >= 50) {
      approvalBracket = 2
    } else if (simulateApproval >= 45) {
      approvalBracket = 1.5
    } else if (simulateApproval >= 40) {
      approvalBracket = 1
    } else {
      approvalBracket = 0
    }
    return approvalBracket
  }

  const calculateFreeLookCancelBracket = () => {
    let freeLookCancelBracket = 0
    if (simulateApproval < 40) {
      freeLookCancelBracket = null
    } else if (simulateFreeLook <= 2.5) {
      freeLookCancelBracket = 5
    } else if (simulateFreeLook <= 5) {
      freeLookCancelBracket = 4.5
    } else if (simulateFreeLook <= 7.5) {
      freeLookCancelBracket = 4
    } else if (simulateFreeLook <= 10) {
      freeLookCancelBracket = 3.5
    } else if (simulateFreeLook <= 12.5) {
      freeLookCancelBracket = 2.5
    } else if (simulateFreeLook <= 15) {
      freeLookCancelBracket = 2
    } else if (simulateFreeLook <= 17.5) {
      freeLookCancelBracket = 1.5
    } else if (simulateFreeLook <= 20) {
      freeLookCancelBracket = 1
    } else if (simulateFreeLook <= 22.5) {
      freeLookCancelBracket = 0.05
    } else {
      freeLookCancelBracket = 0
    }
    return freeLookCancelBracket
  }

  const calculateFourMonthLapseBracket = () => {
    let fourMonthLapseBracket = 0
    if (simulateApproval < 40) {
      fourMonthLapseBracket = null
    } else if (simulateFourMonth == 0) {
      fourMonthLapseBracket = 5
    } else if (simulateFourMonth <= 10) {
      fourMonthLapseBracket = 4
    } else if (simulateFreeLook <= 15) {
      fourMonthLapseBracket = 3.75
    } else if (simulateFourMonth <= 20) {
      fourMonthLapseBracket = 3.5
    } else if (simulateFourMonth <= 25) {
      fourMonthLapseBracket = 3.25
    } else if (simulateFourMonth <= 30) {
      fourMonthLapseBracket = 3
    } else if (simulateFourMonth <= 35) {
      fourMonthLapseBracket = 2.5
    } else if (simulateFourMonth <= 40) {
      fourMonthLapseBracket = 2
    } else if (simulateFourMonth <= 45) {
      fourMonthLapseBracket = 1.5
    } else if (simulateFourMonth <= 50) {
      fourMonthLapseBracket = 1
    } else {
      fourMonthLapseBracket = 0
    }
    return fourMonthLapseBracket
  }

  const handleProductFilterChange = (event) => {
    setProduct(event.target.value)
  }

  const handleAgencyFilterChange = (event) => {
    setAgency(event.target.value)
    setProduct('1')
  }
  const handleDistributorFilterChange = (event) => {
    setDistributor(event.target.value);
    setAgency('1')
  };

  const handleAgentsSearch = (event, value) => {
    if(value != null){
      setProduct('1');
      const data = {
        affiliateCode: value.affCode,
        productId: '1',
        last25: "false",
      };
      const chartData = {
        affiliateCode: value.affCode,
        productId: '1',
        last25: "false"
      }
      props.getScorecard(data);
      props.getScorecardChart(chartData);
    }
  };

  useEffect(()=> {
    if(props.relationalType === 97){
      setAgency(props?.userSourceCode)
    }else if(props.relationalType === 107){
      setDistributor(props?.userSourceCode)
    }
  },[])

  useEffect(()=> {
    let data = {}
    if(props.relationalType === 97) {
      data = {
        agencyId: agency.toString(),
        productId: product.toString(),
      }
    }else{
      data = {
        distributorId: distributor.toString(),
        agencyId: agency.toString(),
        productId: product.toString(),
      }
    }
    const agentData = {
      distributorId: '8973',
      agencyId: agency.toString(),
    }
    props.getScorecardDistributor(data)
    props.getScorecardChartPersona(data)
    props.getAgentList(agentData)
  },[agency, product, distributor])

  useEffect(() => {
    const calculateSimQualityScore = () => {
      const approvalBracket = calculateApprovalBracket()
      const freeLookCancelBracket = calculateFreeLookCancelBracket()
      const fourMonthLapseBracket = calculateFourMonthLapseBracket()
      const newQualityScore = (approvalBracket * 0.5 + freeLookCancelBracket * 0.25 + fourMonthLapseBracket * 0.25) * 2
      setSimulateQualityScore(newQualityScore)
    }
    calculateSimQualityScore()
  }, [
    calculateApprovalBracket,
    calculateFourMonthLapseBracket,
    calculateFreeLookCancelBracket,
    simulateApproval,
    simulateFourMonth,
    simulateFreeLook,
  ])

  useEffect(() => {
    setAgencies(props.agencyList);
    setProducts(props.productList);
    setDistributors(props.distributorList);
  },[props.agencyList, props.productList, props.distributorList])

  useEffect(()=> {
    let data = { 
      agencyId: agency.toString()
    }
    props.getAgencyProductListPersona(data);
  },[agency])

  useEffect(()=> {
    let data = { 
      distributorId: distributor.toString()
    }
    props.getAgencyProductListPersona(data);
  },[distributor])

  useEffect(() => {
    const data = {
      affiliateCode,
      last25: last25,
    }
    const chartData = {
      affiliateCode,
    }
    let upData = {}
    let listData = {}
    if(props.relationalType === 97){
      upData = {
        agencyId: props?.userSourceCode?.toString(),
        productId: '1'
      }
      listData = {
        agencyId: props?.userSourceCode?.toString(),
        initialization: true
      }
    }else if(props.relationalType === 107) {
      upData = {
        distributorId: props?.userSourceCode?.toString(),
        agencyId: '1',
        productId: '1'
      }
      listData = {
        distributorId: props?.userSourceCode?.toString(),
        initialization: true
      }
    }else if(props.relationalType === 117){
      upData = {
        distributorId: '1',
        agencyId: '1',
        productId: '1'
      }
      listData = {
        afficiencyPersona: true
      }
    }
    const scorecardCalls = async () => {
      if (props.relationalType != 87) {
        await props.getScorecardDistributor(upData)
        await props.getScorecardChartPersona(upData)
        await props.getAgencyProductListPersona(listData);
      } else {
        await props.getScorecard(data)
        await props.getScorecardChart(chartData)
      }
      
    }
    scorecardCalls()
  }, [last25])

  useEffect(() => {
    let agentNamesAff = []
    if(props.agentList.length >=1){
    agentNamesAff = props.agentList?.map((agent) =>
      ({
        label: `${agent.name}`,
        affCode: `${agent.affilateCode}`
      })
    )}
    setAgentList(agentNamesAff);
  }, [props.agentList])

  useEffect(() => {
    if (props.chartTotals != null && !props.qualityScore) {
      setNotEnoughMessage(true)
    } else {
      setNotEnoughMessage(false)
    }
  }, [props.chartTotals])

  useEffect(() => {
    if (props.applicationsSubmitted < 25 && last25 == 'false') {
      setDisableLast25(true)
    } else {
      setDisableLast25(false)
    }
  }, [props.qualityScore])

  useEffect(() => {
    if (props.qualityScore >= 8.2) {
      setQualityColor('#30AAA2')
    } else if (props.qualityScore >= 6.8) {
      setQualityColor('#FE891D')
    } else {
      setQualityColor('#CA303A')
    }
  }, [props.qualityScore])

  useEffect(() => {
    if (simulateQualityScore >= 8.2) {
      setSimQualityColor('#30AAA2')
    } else if (simulateQualityScore >= 6.8) {
      setSimQualityColor('#FE891D')
    } else {
      setSimQualityColor('#CA303A')
    }
  }, [simulateQualityScore])

  useEffect(() => {
    if (props.approvalRate >= 80) {
      setApprovalColor('#30AAA2')
    } else if (props.approvalRate >= 70) {
      setApprovalColor('#FE891D')
    } else {
      setApprovalColor('#CA303A')
    }
  }, [props.approvalRate])

  useEffect(() => {
    if (props.freeLookCancel <= 5) {
      setFreeLookColor('#30AAA2')
    } else if (props.freeLookCancel <= 10) {
      setFreeLookColor('#FE891D')
    } else {
      setFreeLookColor('#CA303A')
    }
  }, [props.freeLookCancel])

  useEffect(() => {
    if (props.fourMonthLapseRate <= 10) {
      setFourMonthColor('#30AAA2')
    } else if (props.fourMonthLapseRate <= 20) {
      setFourMonthColor('#FE891D')
    } else {
      setFourMonthColor('#CA303A')
    }
  }, [props.fourMonthLapseRate])

  useEffect(() => {
    if (props.underwritingInaccuracy < 5) {
      setUnderwritingInaccColor('#30AAA2')
    } else if (props.underwritingInaccuracy < 25) {
      setUnderwritingInaccColor('#FE891D')
    } else {
      setUnderwritingInaccColor('#CA303A')
    }
  }, [props.underwritingInaccuracy])

  useEffect(() => {
    if (props.excessiveApplicationActivity < 5) {
      setExcessiveAppColor('#30AAA2')
    } else if (props.excessiveApplicationActivity < 25) {
      setExcessiveAppColor('#FE891D')
    } else {
      setExcessiveAppColor('#CA303A')
    }
  }, [props.excessiveApplicationActivity])

  const handleClose = (event, reason) => {
    setNotEnoughMessage(false)
  }

  const action = (
    <Button onClick={handleClose} color="secondary" size="small">
      <ClearIcon />
    </Button>
  )

  return (
    <div
      style={{
        backgroundColor: 'rgba(241, 243, 246, 1)',
        fontFamily: 'Roboto',
        minHeight: '100vh',
        paddingTop: '15px'
      }}
    >
      {
        <Snackbar
          open={notEnoughMessage}
          autoHideDuration={10000}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          sx={{
            '&.MuiSnackbar-anchorOriginTopRight': { top: '100px' },
          }}
          message="Not enough applications to display Quality Score. To be scored, a minimum of five applications need to be submitted to underwriting."
          action={action}
        />
      }
      <Box sx={{ marginTop: 6 }}>
        <Grid container spacing={3} padding="12px" height="100%">
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <Typography align="left" variant="h1" style={{ padding: '24px 10px', fontSize: '24px' }}>
              My Scorecard
            </Typography>
          </Grid>
          <Grid
            item
            lg={6}
            md={6}
            sm={12}
            xs={12}
            sx={{
              display: 'flex',
              justifyContent: { lg: 'end', md: 'end', sm: 'center', xs: 'center' },
              alignItems: 'center',
              flexDirection: { lg: 'row', md: 'row', sm: 'column', xs: 'column' },
            }}
          >
            {props.relationalType !== 87 ? (
              
              <Grid container spacing={1}>
                <Grid item lg={3} md={3} sm={3} xs={6}>
                {props.relationalType !== 97 && 
                  <TextField
                    select
                    label="Distributor"
                    name="distributor"
                    sx={scorecardStyle.filter}
                    size="small"
                    value={distributor}
                    onChange={handleDistributorFilterChange}
                    disabled={props.relationalType === 107}
                  >
                  {distributors.map((dist) => (
                    <MenuItem key={dist.distributor_name} value={dist.distributor_id}>
                      {dist.distributor_name}
                    </MenuItem>
                  ))}
                  </TextField>
                  }
                </Grid>
                <Grid item lg={3} md={3} sm={3} xs={6}>
                  <TextField
                    select
                    label="Agency"
                    name="agency"
                    sx={scorecardStyle.filter}
                    size="small"
                    value={agency}
                    onChange={handleAgencyFilterChange}
                    disabled={props.relationalType === 97}
                  >
                    {agencies.map((agency) => (
                      <MenuItem key={agency.agency_name} value={agency.agency_id}>
                        {agency.agency_name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
                <Grid item lg={3} md={3} sm={3} xs={6}>
                  <Autocomplete
                    id="combo-box-demo"
                    options={agentList}
                    renderOption={(props, option) => {
                      return (
                        <li {...props} key={option.affCode}>
                          {option.label}
                        </li>
                      )
                    }}
                    onChange={handleAgentsSearch}
                    sx={{ paddingBottom: '5px' }}
                    renderInput={(params) => (
                      <TextField {...params} sx={scorecardStyle.filter} size="small" label="Agents" />
                    )}
                  />
                </Grid>
                <Grid item lg={3} md={3} sm={3} xs={6}>
                  <TextField
                    select
                    label="Product"
                    name="product"
                    sx={scorecardStyle.filter}
                    size="small"
                    value={product}
                    onChange={handleProductFilterChange}
                  >
                    {products.map((product) => (
                      <MenuItem key={product.product_name} value={product.product_id}>
                        {product.product_name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
            ) : (
              <TextField
                select
                label="PRODUCT"
                name="product"
                sx={scorecardStyle.textField}
                size="small"
                defaultValue={'QLT'}
              >
                <MenuItem key="QLT" value="QLT">
                  Quility Level Term / ROP Level Term
                </MenuItem>
              </TextField>
            )}
            {props.relationalType === 87 && (
              <ToggleButtonGroup
                color="primary"
                value={last25}
                exclusive
                onChange={handleLast25Toggle}
                size="small"
                sx={{ height: '38px' }}
                disabled={disableLast25}
              >
                <ToggleButton value="false">All Time</ToggleButton>
                <ToggleButton value="true">Last 25 Applications</ToggleButton>
              </ToggleButtonGroup>
            )}
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Grid container spacing={1}>
              <Grid item lg={12} md={12} sm={12} xs={12} display="flex" flexDirection="row">
                <Typography marginLeft="10px" fontSize="18px">
                  Metric Color Legend:
                </Typography>
                <CircleIcon sx={{ color: '#30AAA2', marginX: '7px' }}></CircleIcon>
                <Typography align="left" marginRight="6px">
                  Excellent
                </Typography>
                <CircleIcon sx={{ color: '#FE891D', marginX: '7px' }}></CircleIcon>
                <Typography align="left" marginRight="6px">
                  Satisfactory
                </Typography>
                <CircleIcon sx={{ color: '#CA303A', marginX: '7px' }}></CircleIcon>
                <Typography align="left" marginRight="6px">
                  Improvement Needed
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item lg={6} md={12} sm={12} xs={12}>
            <Paper
              sx={{
                padding: '16px',
                boxShadow: '0px 4px 20px -4px rgba(16, 24, 40, 0.08);',
              }}
              variant="outlined"
            >
              <Grid container spacing={2}>
                <Grid item lg={3} md={3} sm={6} xs={6} display="flex" flexDirection="row" justifyContent="center">
                  <Typography fontSize={'16px'}>QUALITY SCORE</Typography>
                  <Tooltip title={qualityScoreMessage}>
                    <InfoIcon fontSize={'small'} sx={{ marginX: '5px', color: '#8F9CAD' }}></InfoIcon>
                  </Tooltip>
                </Grid>
                <Grid item lg={9} md={9} sm={6} xs={6} display="flex" justifyContent="end" alignItems="end">
                  <Box>
                    <ToggleButtonGroup
                      color="primary"
                      value={simulateStatus}
                      exclusive
                      onChange={handleSimulateToggle}
                      size="small"
                      sx={{ height: '25px' }}
                      disabled={!props.qualityScore}
                    >
                      <ToggleButton value="actual">Actual</ToggleButton>
                      <ToggleButton value="simulate">Simulate</ToggleButton>
                    </ToggleButtonGroup>
                  </Box>
                </Grid>
                <Grid item lg={3} md={3} sm={12} xs={12} display="flex" alignItems="start" justifyContent="center">
                  <Box sx={scorecardStyle.ratingCircle}>
                    {simulateFields == true ? (
                      <Typography fontSize="48px" fontFamily="Roboto Slab" color={simQualityColor}>
                        {simulateQualityScore.toFixed(1)}
                      </Typography>
                    ) : props.qualityScore == null ? (
                      <Typography fontSize="48px" fontFamily="Roboto Slab" color="#3C4FB9">
                        -
                      </Typography>
                    ) : (
                      <Typography fontSize="48px" fontFamily="Roboto Slab" color={qualityColor}>
                        {props.qualityScore}
                      </Typography>
                    )}
                  </Box>
                </Grid>
                <Grid item lg={3} md={3} sm={12} xs={12}>
                  <Box sx={scorecardStyle.scoreFields}>
                    {simulateFields == true ? (
                      <Typography>
                        <TextField
                          onChange={handleApprovalSimulate}
                          defaultValue={simulateApproval}
                          sx={{ width: '80%' }}
                          type="number"
                        ></TextField>
                        %
                      </Typography>
                    ) : props.qualityScore == null ? (
                      <Typography sx={scorecardStyle.statsNumber}>-</Typography>
                    ) : (
                      <Typography sx={scorecardStyle.statsNumber} color={approvalColor}>
                        {props.approvalRate}%
                      </Typography>
                    )}
                    <Typography fontSize={'12px'}>Approval Rate</Typography>
                    <Tooltip title={approvalRateMessage}>
                      <InfoIcon fontSize={'small'} sx={{ color: '#8F9CAD', marginTop: 'auto' }}></InfoIcon>
                    </Tooltip>
                  </Box>
                  <Typography fontSize={'12px'} color={'#8F9CAD'} padding="5px">
                    Weight 50%
                  </Typography>
                </Grid>
                <Grid item lg={3} md={3} sm={12} xs={12}>
                  <Box sx={scorecardStyle.scoreFields}>
                    {simulateFields == true ? (
                      <Typography>
                        <TextField
                          onChange={handleFreeLookSimulate}
                          defaultValue={simulateFreeLook}
                          sx={{ width: '80%' }}
                          type="number"
                        ></TextField>
                        %
                      </Typography>
                    ) : props.qualityScore == null ? (
                      <Typography sx={scorecardStyle.statsNumber}>-</Typography>
                    ) : (
                      <Typography sx={scorecardStyle.statsNumber} color={freeLookColor}>
                        {props.freeLookCancel}%
                      </Typography>
                    )}
                    <Typography fontSize={'12px'}>Free Look Cancel/First Payment Failure Rate</Typography>
                    <Tooltip title={freeLookCancelMessage}>
                      <InfoIcon fontSize={'small'} sx={{ color: '#8F9CAD', marginTop: 'auto' }}></InfoIcon>
                    </Tooltip>
                  </Box>
                  <Typography fontSize={'12px'} color={'#8F9CAD'} padding="5px">
                    Weight 25%
                  </Typography>
                </Grid>
                <Grid item lg={3} md={3} sm={12} xs={12}>
                  <Box sx={scorecardStyle.scoreFields}>
                    {simulateFields == true ? (
                      <Typography>
                        <TextField
                          onChange={handleFourMonthSimulate}
                          defaultValue={simulateFourMonth}
                          sx={{ width: '80%' }}
                          type="number"
                        ></TextField>
                        %
                      </Typography>
                    ) : props.qualityScore == null ? (
                      <Typography sx={scorecardStyle.statsNumber}>-</Typography>
                    ) : (
                      <Typography sx={scorecardStyle.statsNumber} color={fourMonthColor}>
                        {props.fourMonthLapseRate}%
                      </Typography>
                    )}
                    <Typography fontSize={'12px'}>4 Month Lapse Rate</Typography>
                    <Tooltip title={fourMonthLapseMessage}>
                      <InfoIcon fontSize={'small'} sx={{ color: '#8F9CAD', marginTop: 'auto' }}></InfoIcon>
                    </Tooltip>
                  </Box>
                  <Typography fontSize={'12px'} color={'#8F9CAD'} padding="5px">
                    Weight 25%
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>

          <Grid item lg={6} md={12} sm={12} xs={12} display="flex" justifyContent="center" alignItems="center">
            <Grid container spacing={2} display="flex" justifyContent="center" alignItems="center">
              <Grid item lg={3} md={3} sm={12} xs={12}>
                <Paper sx={scorecardStyle.statFields} variant="outlined">
                  <Box sx={scorecardStyle.statsWrapper}>
                    {props.qualityScore == null ? (
                      <Typography sx={scorecardStyle.statsNumberVariant} color="#3C4FB9">
                        -
                      </Typography>
                    ) : (
                      <Typography sx={scorecardStyle.statsNumberVariant} color={underwritingInaccColor}>
                        {props.underwritingInaccuracy}%
                      </Typography>
                    )}
                    <Typography fontSize={'12px'} color="#36414E">
                      Field Underwriting Inaccuracy Rate
                    </Typography>
                    <Tooltip title={fieldUWInaccuracyMessage}>
                      <InfoIcon
                        fontSize={'small'}
                        sx={{ marginY: '10px', color: '#8F9CAD', marginTop: 'auto' }}
                      ></InfoIcon>
                    </Tooltip>
                  </Box>
                </Paper>
              </Grid>
              <Grid item lg={3} md={3} sm={12} xs={12}>
                <Paper sx={scorecardStyle.statFields} variant="outlined">
                  <Box sx={scorecardStyle.statsWrapper}>
                    {props.excessiveApplicationActivity == null ? (
                      <Typography sx={scorecardStyle.statsNumberVariant} color="#3C4FB9">
                        -
                      </Typography>
                    ) : (
                      <Typography sx={scorecardStyle.statsNumberVariant} color={excessiveAppColor}>
                        {props.excessiveApplicationActivity}%
                      </Typography>
                    )}
                    <Typography fontSize={'12px'} color="#36414E">
                      Excessive Application Activity Rate
                    </Typography>
                    <Tooltip title={excessiveAppActivityMessage}>
                      <InfoIcon
                        fontSize={'small'}
                        sx={{ marginY: '10px', color: '#8F9CAD', marginTop: 'auto' }}
                      ></InfoIcon>
                    </Tooltip>
                  </Box>
                </Paper>
              </Grid>
              <Grid item lg={3} md={3} sm={12} xs={12}>
                <Paper sx={scorecardStyle.statFields} variant="outlined">
                  <Box sx={scorecardStyle.statsWrapper}>
                    <Typography sx={scorecardStyle.statsNumberVariant} color="#3C4FB9">
                      {props.applicationsSubmitted}
                    </Typography>
                    <Typography fontSize={'12px'} color="#36414E">
                      # of Applications
                    </Typography>
                    <Tooltip title={numApplicationsMessage}>
                      <InfoIcon
                        fontSize={'small'}
                        sx={{ marginY: '10px', color: '#8F9CAD', marginTop: 'auto' }}
                      ></InfoIcon>
                    </Tooltip>
                  </Box>
                </Paper>
              </Grid>
              <Grid item lg={3} md={3} sm={12} xs={12}>
                <Paper sx={scorecardStyle.statFields} variant="outlined">
                  <Box sx={scorecardStyle.statsWrapper}>
                    <Typography sx={scorecardStyle.statsNumberVariant} color="#3C4FB9">
                      {Math.floor(props.policiesIssued)}
                    </Typography>
                    <Typography fontSize={'12px'} color="#36414E">
                      # of Policies Issued
                    </Typography>
                    <Tooltip title={numPoliciesIssued}>
                      <InfoIcon
                        fontSize={'small'}
                        sx={{ marginY: '10px', color: '#8F9CAD', marginTop: 'auto' }}
                      ></InfoIcon>
                    </Tooltip>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </Grid>

          <Typography align="left" fontSize={'12px'} marginX="24px" marginY="6px">
            Data displayed is current as of previous day.
          </Typography>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <Paper
              sx={{
                padding: '16px',
                boxShadow: '0px 4px 20px -4px rgba(16, 24, 40, 0.08);',
              }}
              variant="outlined"
            >
              <Grid container spacing={1}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Typography align="left">HOW CLOSE AM I TO TOP PERFORMERS?</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={1}>
                <Grid item lg={10} md={10} sm={10} xs={12}>
                  {props?.chartTotals == null && (
                    <Typography>Loading...</Typography>
                  )}
                  {props.chartTotals?.length > 0 && (
                    <PerformanceScatterplot
                      qualityScore={simulateFields ? simulateQualityScore : props.qualityScore}
                      uwInaccuracy={props.underwritingInaccuracy}
                      chartTotals={props?.chartTotals}
                    />
                  )}
                </Grid>
                <Grid item lg={2} md={2} sm={2} xs={12} display="flex" alignItems="center" justifyContent="center">
                  <Grid container spacing={1}>
                    {props.relationalType===87 && 
                    <Grid item lg={3} md={3} sm={3} xs={3} display="flex" justifyContent="end">
                      <StarIcon sx={{ color: 'rgba(254, 137, 29, 0.7)' }}></StarIcon>
                    </Grid>}
                    {props.relationalType===87 &&
                    <Grid item lg={9} md={9} sm={9} xs={9}>
                      <Typography align="left">You</Typography>
                    </Grid>}
                    <Grid item lg={3} md={3} sm={3} xs={3} display="flex" justifyContent="end">
                      <CircleIcon sx={{ color: 'rgba(17, 23, 68, 0.7)' }}></CircleIcon>
                    </Grid>
                    <Grid item lg={9} md={9} sm={9} xs={9}>
                      <Typography align="left">More than 100 agents</Typography>
                    </Grid>
                    <Grid item lg={3} md={3} sm={3} xs={3} display="flex" justifyContent="end">
                      <CircleIcon sx={{ color: 'rgba(31, 42, 122, 0.7)' }}></CircleIcon>
                    </Grid>
                    <Grid item lg={9} md={9} sm={9} xs={9}>
                      <Typography align="left">Between 50 and 100 agents</Typography>
                    </Grid>
                    <Grid item lg={3} md={3} sm={3} xs={3} display="flex" justifyContent="end">
                      <CircleIcon sx={{ color: 'rgba(47, 64, 187, 0.7)' }}></CircleIcon>
                    </Grid>
                    <Grid item lg={9} md={9} sm={9} xs={9}>
                      <Typography align="left">Between 30 to 50 agents</Typography>
                    </Grid>
                    <Grid item lg={3} md={3} sm={3} xs={3} display="flex" justifyContent="end">
                      <CircleIcon sx={{ color: 'rgba(102, 116, 217, 0.7)' }}></CircleIcon>
                    </Grid>
                    <Grid item lg={9} md={9} sm={9} xs={9}>
                      <Typography align="left">Between 10 to 30 agents</Typography>
                    </Grid>
                    <Grid item lg={3} md={3} sm={3} xs={3} display="flex" justifyContent="end">
                      <CircleIcon sx={{ color: 'rgba(170, 178, 234, 0.7)' }}></CircleIcon>
                    </Grid>
                    <Grid item lg={9} md={9} sm={9} xs={9}>
                      <Typography align="left">Less than 10 agents</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </div>
  )
}

export default Scorecard;

const scorecardStyle = {
  ratingCircle: {
    backgroundColor: '#C4CAF1',
    borderRadius: '50%',
    minHeight: '110px',
    minWidth: '110px',
    maxHeight: '110px',
    maxWidth: '110px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  scoreFields: {
    backgroundColor: '#F5F7FF',
    color: 'rgba(100, 118, 140, 1)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'center',
    padding: '9px',
    borderRadius: '8px',
    height: '70%',
  },

  statFields: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '8px',
    padding: '9px',
    height: '100%',
    boxShadow: '0px 4px 20px -4px rgba(16, 24, 40, 0.08);',
  },

  statsNumber: {
    fontWeight: '500',
    fontSize: '36px',
    fontFamily: 'Roboto Slab',
  },

  statsNumberVariant: {
    fontWeight: '500',
    fontSize: '36px',
    fontFamily: 'Roboto Slab',
  },

  statsWrapper: {
    height: '145px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    flexDirection: 'column',
    padding: '18px 20px 0px 20px',
  },

  paper: {
    padding: '16px',
    boxShadow: '0px 4px 20px -4px rgba(16, 24, 40, 0.08);',
  },

  textField: {
    textAlign: 'left',
    backgroundColor: 'white',
    width: { lg: '20%', md: '30%', sm: '238px', xs: '238px' },
    margin: '5px',
  },

  filter: {
    textAlign: 'left',
    backgroundColor: 'white',
    width: { lg: '85%', md: '85%', sm: '238px', xs: '238px' },
    margin: '5px',
  },
};
